<template>
    <el-card v-loading="!is_ok" class="page_card" ref="card">
        <el-form :inline="true" ref="selectForm" :model="selectForm" class="demo-form-inline">
            <el-form-item label="企业名称/简称">
                <el-select
                    v-model="selectForm.comId"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    @change="changeCom"
                    :loading="is_select">
                    <el-option
                        v-for="item in componys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input placeholder="客户姓名" v-model="selectForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input placeholder="手机号" v-model="selectForm.mobile"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="selectForm.valid" placeholder="请选择" style="width: 90px">
                    <el-option
                        v-for="item in valids"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="是否认证">
                <el-select v-model="selectForm.status" placeholder="请选择" style="width: 90px">
                    <el-option
                        v-for="item in status"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button plain type="primary" :loading="is_post" @click="selectSubmit()">查询</el-button>
                <el-button plain :loading="is_post" @click="resetSelect()">重置</el-button>
                <el-button plain type="success" @click="addBtn()" v-if="((roles.includes('client')||roles.includes('client_sub'))&&userinfo.main)||roles.includes('admin')||roles.includes('seller')||roles.includes('seller_director')" v-can="['btn:add_customer']">+ 新增企业联系人</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="data" v-loading="is_loading"  v-if="showtable" stripe :max-height="tableMaxHeight">
            <el-table-column label="企业名称">
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.comName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="姓名">
                <template slot-scope="scope">
                    {{scope.row.name}}
                </template>
            </el-table-column>
            <el-table-column label="职务">
                <!-- <template slot-scope="scope">
                    <div>
                        {{scope.row.name}}
                    </div>
                    <div v-if="scope.row.jobName && scope.row.jobName.length">
                        <span class="primary_text">{{ scope.row.jobName }}</span>
                    </div>
                </template> -->
                 <template slot-scope="scope">
                    {{scope.row.jobName}}
                 </template>
            </el-table-column>
            <el-table-column label="注册手机号">
                <template slot-scope="scope">
                    {{scope.row.mobile}}
                </template>
            </el-table-column>
            <el-table-column label="微信账号">
                <template slot-scope="scope">
                    <div>
                        <span class="success_text">{{scope.row.wechat}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="其他联系方式">
                <template slot-scope="scope">
                    <div v-if="scope.row.email.length > 0">
                        邮箱 : {{scope.row.email}}
                    </div>
                    <div v-if="scope.row.otherContactName.length>0">
                        {{scope.row.otherContactName}} : {{scope.row.otherContactCon}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="是否主管理员">
                <template slot-scope="scope">
                    <span class="primary_text" v-if="scope.row.isMain == 1">是</span>
                    <span class="warning_text" v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.isValid == 1" class="success_text">正常</span>
                    <span v-else class="warning_text">禁用</span>
                    <!-- &nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-if="scope.row.status > 0" class="success_text">已认证</span>
                    <span v-else class="warning_text">未认证</span> -->
                </template>
            </el-table-column>
            <el-table-column label="备注">
                <template slot-scope="scope">
                    <div v-if="scope.row.remark.length">
                        {{scope.row.remark}}
                    </div>
                    <div v-else>
                        无
                    </div>
                </template>
            </el-table-column>
            <!--  v-if="has_permission('btn:edit_customer')" -->
            <el-table-column label="操作" width="210">
                <template slot-scope="scope" v-if="((roles.includes('client')||roles.includes('client_sub'))&&scope.row.isMain ==false&&userinfo.main)||roles.includes('admin')||roles.includes('seller')||roles.includes('seller_director')">
                    <el-button type="warning" v-can="['btn:modify_customer']" class="warning_text" size="mini" plain @click="clickDrop('edit',scope.row)">
                         修改
                    </el-button>
                    <el-button type="success" v-can="['btn:limit_customer']" class="success_text" size="mini" plain v-if="scope.row.isValid == 0"  @click="clickDrop('redel',scope.row)">
                         恢复
                    </el-button>
                    <el-button type="danger" v-can="['btn:limit_customer']" class="danger_text" size="mini" plain v-if="scope.row.isValid == 1"  @click="clickDrop('del',scope.row)">
                         禁用
                    </el-button>
                    <el-button type="danger" v-can="['btn:delete_customer']" class="danger_text" size="mini" plain  @click="clickDrop('delete',scope.row)">
                         删除
                    </el-button>
                    <!-- <el-dropdown trigger="click" placement="bottom-start" @command="clickDrop($event,scope.row)">
                        <el-button type="primary" size="mini" plain>
                            <svg-icon icon-class="many"/>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item class="warning_text" command="edit">
                                <svg-icon icon-class="change"/>
                                修改
                            </el-dropdown-item>
                            <el-dropdown-item class="success_text" command="redel" v-if="scope.row.isValid == 0">
                                <i class="el-icon-refresh-left" />
                                恢复
                            </el-dropdown-item>
                            <el-dropdown-item class="danger_text" command="del" v-if="scope.row.isValid == 1">
                                <svg-icon icon-class="dis"/>
                                禁用
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                </template>
            </el-table-column>
        </el-table>
        <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :hide-on-single-page="false"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer>

        <el-dialog :title="id==0?'添加企业联系人':'修改企业联系人'" :visible.sync="add_dialog" width="30%">
            <el-form label-position="right" ref="addForm" :rules="rules" label-width="130px" :model="addForm" style="padding: 0 20px;">
                <el-form-item label="客户姓名" prop="name">
                    <el-input v-model="addForm.name" placeholder="请输入客户姓名" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="所属公司" prop="comId" v-if="id == 0 && (roles.includes('admin')||roles.includes('seller')||roles.includes('seller_director'))">
                    <el-select
                        style="width: 100%"
                        ref="addSelect"
                        v-model="addForm.comId"
                        :multiple="false"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入企业名称或简称"
                        :loading="is_select">
                        <el-option
                            v-for="item in componys"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属公司" prop="companyName" v-if="roles.includes('client')||roles.includes('client_sub')">
                    <el-input v-model="userinfo.companyName" disabled></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="gender">
                    <el-radio-group v-model="addForm.gender">
                        <el-radio-button label="1">男</el-radio-button>
                        <el-radio-button label="2">女</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="登录手机号" prop="mobile">
                    <el-input v-model="addForm.mobile" placeholder="登录手机号" maxlength="11" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="职务">
                    <el-input v-model="addForm.jobName" placeholder="职务" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="email" prop="email">
                    <el-input v-model="addForm.email" placeholder="联系邮箱" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="微信账号" prop="wechat">
                    <el-input v-model="addForm.wechat" placeholder="微信账号" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="其他联系方式名称">
                    <el-input v-model="addForm.otherContactName" placeholder="联系方式名称" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="其他联系方式内容">
                    <el-input v-model="addForm.otherContactCon" placeholder="联系方式内容" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="addForm.remark" placeholder="备注" type="textarea" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="是否主账号">
                    <el-switch
                        style="display: block"
                        v-model="addForm.isMain"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="主账号"
                        inactive-text="非主账号">
                    </el-switch>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-switch
                        style="display: block"
                        v-model="addForm.isValid"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="启用"
                        inactive-text="暂不启用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button plain v-if="id == 0" type="primary" :loading="is_post" @click="addSubmit()">提 交</el-button>
                    <el-button plain v-else type="warning" :loading="is_post" @click="editSubmit()">提交修改</el-button>
                    <el-button plain :loading="is_post" @click="resetAdd()">重 置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-card>
</template>

<script>
import request from "@/utils/request"
import {validEmail,stringTrim} from "@/utils/elvalid"
import {deepClone} from "@/utils"

import can from "@/directive/can/index.js"
import {mapGetters} from 'vuex'

export default {
    name: 'customer_user',
    directives:{can},
    computed:{
        ...mapGetters([
            'permissions',
            'roles',
            'userinfo',
        ])
    },
    data(){
        return {
            is_ok:false,
            is_loading:false,
            is_post:false,
            add_dialog:false,
            data:[],
            active_item:null,
            is_select:false,
            selectForm:{
                name:"",
                mobile:"",
                comId:"",
                status:"all",
                valid:"all",
                pageNum: 1,
                pageSize: 10
            },
            rules:{
                name:[
                    { required: true, message: '请输入该用户姓名', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' },
                    { min: 1, max: 10, message: '最长不超过10个字符', trigger: 'blur' }
                ],
                comId:[
                    { required: true, message: '请选择所属企业', trigger: 'blur' }
                ],
                gender:[
                    { required: true, message: '请选择用户性别', trigger: 'blur' }
                ],
                mobile:[
                    { required: true, message: '请输入该用户的手机号', trigger: 'blur' },
                    {pattern:/\d{11}/,message: "请输入正确的手机号"}
                ],
                wechat:[
                    {pattern:/^[a-zA-Z-_][a-zA-Z-_0-9]{5,19}$/,message: "请输入正确的微信账号",trigger:'blur'}
                ],
                email:[
                    { validator: validEmail, trigger: 'blur' }
                ]
            },
            addForm:{
                comId: "",
                email: "",
                gender: 1,
                jobName: "",
                mobile: "",
                name: "",
                otherContactCon: "",
                otherContactName: "",
                isMain: true,
                remark: "",
                isValid: true,
                wechat: ""
            },
            id:0,
            total:0,
            componys:[

            ],
            componys_add:[

            ],
            componys_edit:[

            ],
            status:[
                {id:"all",label:"全部"},
                {id:1,label:"已认证"},
                {id:0,label:"未认证"},
            ],
            valids:[
                {id:"all",label:"全部"},
                {id:1,label:"启用"},
                {id:0,label:"禁用"},
            ],
            tableMaxHeight:0,
            showtable:false

        }
    },
    methods:{
        addBtn(){
            if(this.id > 0){
                this.addForm = {
                    comId: "",
                    email: "",
                    gender: 1,
                    jobName: "",
                    mobile: "",
                    name: "",
                    otherContactCon: "",
                    otherContactName: "",
                    isMain: true,
                    remark: "",
                    isValid: true,
                    wechat: ""
                };
            }
            this.id = 0;
            this.add_dialog = true;
        },
        selectSubmit(){
            this.getData();
        },
        resetSelect(){
            this.selectForm = {
                name:"",
                mobile:"",
                comId:"",
                status:"all",
                valid:"all",
                pageNum: 1,
                pageSize: 10
            };
            this.$refs["selectForm"].resetFields();
            this.getData();
        },
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
        getData(is_init = false){
            if(!is_init){
                this.is_loading = true;
                this.is_post = true;
            }
            request.post("customer/list",this.selectForm).then(res=>{
                this.data = res.data.list;
                this.total = res.data.total;
                if(!is_init){
                    this.is_loading = false;
                    this.is_post = false;
                }else{
                    this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                    this.showtable = true
                    this.is_ok = true;
                }
            }).catch(err=>{
                if(!is_init){
                    this.is_loading = false;
                    this.is_post = false;
                }else{
                    this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                    this.showtable = true
                    this.is_ok = true;
                }
            })
        },
        selectComMethod(name,t){
            if(name.length > 1){
                this.is_select = true;
                request.get("company/option?keyword="+name).then(res=>{
                    if(res.data && res.data.length > 0){
                        if(t == "select"){
                            this.componys = res.data;
                        }else if(t == "add"){
                            this.componys_add = res.data;
                        }else if(t == "edit"){
                            this.componys_edit = res.data;
                        }
                    }else{
                        if(t == "select"){
                            this.componys = [];
                        }else if(t == "add"){
                            this.componys_add = [];
                        }else if(t == "edit"){
                            this.componys_edit = [];
                        }
                    }
                    this.is_select = false;
                }).catch(err=>{
                    this.is_select = false;
                    console.log(err);
                });
            }
        },
        selectComMethodAdd(name){
            this.selectComMethod(name,"add");
        },
        selectComMethodEdit(name){
            this.selectComMethod(name,"edit");
        },
        selectComMethodSelect(name){
            this.selectComMethod(name,"select");
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
            }).catch(err=>{
            });
        },
        changeCom(e){
            this.selectForm.comId=e;
            this.getData();
        },
        clickDrop(t,item){
            this.active_item = item;
            if(t == "edit"){
                this.componys_add = [];
                this.componys_add.push({id:item.comId,name:item.comName});
                for(let k of Object.keys(this.addForm)){
                    if(typeof this.active_item[k] != "undefined"){
                        this.addForm[k] = this.active_item[k];
                    }
                }
                this.id = item.id;
                this.add_dialog = true;
            }else if(t == "del"){
                this.$confirm('此操作将禁用该用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.is_post = true;
                    request.post("customer/change_status",{id:item.id,valid:false}).then(res=>{
                        item.isValid = 0;
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                })
            }else if(t == "delete"){
                this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.is_post = true;
                    request.post("customer/delete",{id:item.id}).then(res=>{
                        item.isValid = 0;
                        this.is_post = false;
                        this.getData();
                    }).catch(err=>{
                        this.is_post = false;
                    });
                })
            }else if(t == "redel"){
                this.is_post = true
                request.post("customer/change_status",{id:item.id,valid:true}).then(res=>{
                    item.isValid = 1;
                    this.$message.success("恢复账号成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            }
        },
        addSubmit(){
            this.$refs["addForm"].validate(valid=>{
                if(!valid)return false;
                this.is_post = true;
                if(this.roles.includes('client')||this.roles.includes('client_sub')){
                    this.addForm.comId=this.userinfo.companyId;
                }
                request.post("customer/create",this.addForm).then(res=>{
                    this.data.unshift(res.data);
                    this.add_dialog = false;
                    this.addForm = {
                        comId: "",
                        email: "",
                        gender: 1,
                        jobName: "",
                        mobile: "",
                        name: "",
                        otherContactCon: "",
                        otherContactName: "",
                        isMain: true,
                        remark: "",
                        isValid: true,
                        wechat: ""
                    };
                    this.$refs["addForm"].resetFields();
                    this.$message.success("创建用户信息成功!");
                    this.componys_add = [];
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        editSubmit(){
            this.$refs["addForm"].validate(valid=>{
                if(!valid)return false;
                this.is_post = true;
                let data = deepClone(this.addForm);
                data.id = this.id;
                request.post("customer/edit",data).then(res=>{

                    console.log(res);

                    for(let k of Object.keys(res.data)){
                        if(typeof this.active_item[k] != "undefined"){
                            this.active_item[k] = res.data[k];
                        }
                    }
                    this.add_dialog = false;
                    this.addForm = {
                        comId: "",
                        email: "",
                        gender: 1,
                        jobName: "",
                        mobile: "",
                        name: "",
                        otherContactCon: "",
                        otherContactName: "",
                        isMain: true,
                        remark: "",
                        isValid: true,
                        wechat: ""
                    };
                    this.$message.success("修改用户信息成功!");
                    this.componys_add = [];
                    this.$refs["addForm"].resetFields();
                    this.is_post = false;
                }).catch(err=>{
                    this.componys_add = [];
                    this.is_post = false;
                });
            });
        },
        resetAdd(){
            this.componys_add = [];
            this.addForm = {
                comId: "",
                email: "",
                gender: 1,
                jobName: "",
                mobile: "",
                name: "",
                otherContactCon: "",
                otherContactName: "",
                isMain: true,
                remark: "",
                isValid: true,
                wechat: ""
            };
            this.$refs["addForm"].resetFields();
        }
    },
    created(){

    },
    mounted() {
        this.getData(true);
        this.getCompany();
    }
}
</script>

<style scoped lang="scss">

</style>
